var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPolicyDocView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M3.6 8v12.333h7.2c.442 0 .8.373.8.834 0 .46-.358.833-.8.833H3.6c-.884 0-1.6-.746-1.6-1.667V6.653L6.499 2H16.4c.884 0 1.6.746 1.6 1.667V9.5c0 .46-.358.833-.8.833-.442 0-.8-.373-.8-.833V3.667H8v2.905C8 7.361 7.36 8 6.572 8H3.6zm2.972-3.727L4.349 6.572h2.223V4.273zm14.404 9.728c-.06 1.379-.118 2.24-.18 2.633C20.334 19.626 17.79 22 16.005 22c-1.794 0-4.33-2.38-4.757-5.376-.07-.492-.14-1.356-.214-2.61l-.033-.56L16.004 11 21 13.45l-.024.551zm-5.938 1.011a.633.633 0 0 0 .28-.844.618.618 0 0 0-.835-.282l-1.622.82.163 1.842c.03.346.332.601.674.57a.627.627 0 0 0 .564-.683l-.087-.986.863-.437z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolicyDocView);
export default __webpack_public_path__ + "static/media/icon-policy-doc-view.c5098a8813f9dcd5144ee66e2d25587b.svg";
export { ForwardRef as ReactComponent };